module.exports = __webpack_public_path__ + "media/1.1237a942.mp4";